import { render } from "./HomePage.vue?vue&type=template&id=c68e69ae&scoped=true"
import script from "./HomePage.vue?vue&type=script&lang=js"
export * from "./HomePage.vue?vue&type=script&lang=js"

import "./HomePage.vue?vue&type=style&index=0&id=c68e69ae&scoped=true&lang=css"

import exportComponent from "/Users/johnahnz0rs/00 - JAHN PROJECTS/frequency-lists/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c68e69ae"]])

export default __exports__